import { useTranslation } from 'next-i18next';
import Icon from '@/components/common/iconedLinks/Icon';
import { URLS } from '@/constants/urls';
import styles from './virtual-assistant-thinking.module.scss';

type Props = {
	thinking: boolean;
};

export const VirtualAssistantThinking = ({ thinking }: Props) => {
	const { t } = useTranslation('alter');
	if (!thinking) {
		return (
			<div className={styles.container}>
				<Icon src={URLS.SPARKLES_STARS_PURPLE} alt={t('icon')} height={24} width={24} />
			</div>
		);
	}
	const dots = 3;
	return (
		<div className={styles.container}>
			{Array.from({ length: dots }).map((_, i) => (
				<span key={i} className={styles.dot} style={{ animationDelay: `${i * 0.15}s` }} />
			))}
		</div>
	);
};
